export default "__VITE_ASSET__b39d96b0__"